module.exports = __webpack_public_path__ + "static/media/moose-shape.59db311c.svg";